import { Component, EventEmitter, Output } from '@angular/core';
import { ModalContainerComponent } from "../../../domain/shared/component/modal-container/modal-container.component";
import {
  EmptyStateStandardComponent,
} from "../../../domain/empty-state/empty-state-standard/empty-state-standard.component";

@Component({
  selector: 'app-modal-expired-session',
  standalone: true,
  templateUrl: './modal-expired-session.component.html',
  styleUrl: './modal-expired-session.component.scss',
  imports: [
    ModalContainerComponent,
    EmptyStateStandardComponent,
  ],
})
export class ModalExpiredSessionComponent {
  @Output() goToLoginEmitter = new EventEmitter<void>();

  goToLogin(): void {
    this.goToLoginEmitter.emit();
  }
}
